<template>
	<button @click.stop="onClick" :disabled="disabled" class="btn">
		<slot /><span v-if="label" class="label">{{ label }}</span>
	</button>
</template>

<script>
export default {
	name: 'IconButton',
	props: {
		label: String,
		disabled: {
			type: Boolean,
			default: false
		}
	},
	methods: {
		onClick(event) {
			this.$emit('click', event)
		}
	}
}
</script>

<style lang="scss" scoped>
@import '~scss/components';

.btn {
	@include button();
	display: flex;
	align-items: center;

	svg {
		display: block;
	}
}

.label {
	margin-left: 0.5rem;
}
</style>
